export default "__VITE_ASSET__Bn$WL$bU__"